export default function XML_Certificate() {
  return (
    <div>
      <h1>XML_Certificate</h1>
      <p>This is the XML_Certificate component.</p>
    </div>
  );
}